import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { MdRefresh } from "react-icons/md";
import { TbEdit } from "react-icons/tb";
import { FaCircleArrowDown, FaCircleArrowUp } from "react-icons/fa6";
import {
  getActiveOrders,
  updateStatus,
  updateOrder,
} from "../../../server/ActiveOrder";

const statusStyles = {
  1: { backgroundColor: "#FF96FF97", label: "תקין" },
  2: { backgroundColor: "Orange", label: "שעת האספקה מתקרב" },
  3: { backgroundColor: "red", label: "איחור" },
  5: { backgroundColor: "LightYellow", label: "לא ידוע" },
};

const orderStatuses = [
  { id: 2, label: "ממתין לליקוט" },
  { id: 4, label: "בליקוט רובוט" },
  { id: 5, label: "הזמנה סגורה" },
  { id: 6, label: "סיום רובוט" },
];

const Orders = () => {
  const [orderList, setOrderList] = useState([]);
  const [toShow, setToShow] = useState(25);
  const [lastRefresh, setLastRefresh] = useState(null);
  const [orderCount, setOrderCount] = useState(0);
  const stationId = useSelector((state) => state.user.stationId);
  const [pCounter, setPCounter] = useState([]);
  const [pFrom, setPFrom] = useState(0);
  const [pTo, setPTo] = useState(24);
  const [cFrom, setCFrom] = useState(0);
  const [cTo, setCTo] = useState(5);
  const [editingOrderId, setEditingOrderId] = useState(null);
  const [selectedValues, setSelectedValues] = useState({});

  const fetchOrders = useCallback(async () => {
    try {
      const response = await getActiveOrders(stationId, toShow);
      console.log(response.data);
      const sortedOrders = response.data.sort(
        (a, b) => a.OrderById - b.OrderById
      );
      setOrderList(sortedOrders);
      setLastRefresh(new Date().toLocaleString("he-IL"));
      setOrderCount(response.data.length);
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  }, [stationId, toShow]);

  useEffect(() => {
    fetchOrders();
    const intervalId = setInterval(fetchOrders, 60000);
    return () => clearInterval(intervalId);
  }, [fetchOrders]);

  const showPaggination = (number) => {
    let val = number * toShow;
    setCFrom(number);
    setCTo(number + 5);
    setPFrom(val);
    setPTo(val + toShow);
    window.scrollTo(0, 0);
  };

  const UpPaggination = () => {
    setCFrom(cFrom + 1);
    setCTo(cTo + 1);
    setPFrom(pFrom + toShow);
    setPTo(pTo + toShow);
    window.scrollTo(0, 0);
  };

  const downPaggination = () => {
    setCFrom(cFrom - 1);
    setCTo(cTo - 1);
    setPFrom(pFrom - toShow);
    setPTo(pTo - toShow);
    window.scrollTo(0, 0);
  };

  const toShowFun = (num) => {
    let pCounter = Array.from(Array(Math.ceil(orderList.length / num)).keys());
    setToShow(num);
    setPCounter(pCounter);
    setPFrom(0);
    setPTo(num);
    setCFrom(0);
    setCTo(5);
    window.scrollTo(0, 0);
  };

  const updateOrderStatus = async (orderNumber, newStatus) => {
    try {
      await updateStatus(orderNumber, newStatus);
      fetchOrders();
      setEditingOrderId(null);
    } catch (error) {
      console.error("Error updating order status:", error);
    }
  };

  const moveOrder = async (orderId, direction) => {
    const orderIndex = orderList.findIndex((order) => order.H === orderId);
    const newOrderList = [...orderList];

    if (direction === "up" && orderIndex > 0) {
      [newOrderList[orderIndex], newOrderList[orderIndex - 1]] = [
        newOrderList[orderIndex - 1],
        newOrderList[orderIndex],
      ];

      await updateOrder(newOrderList[orderIndex - 1].H, orderIndex);
      await updateOrder(newOrderList[orderIndex].H, orderIndex - 1);
    } else if (direction === "down" && orderIndex < orderList.length - 1) {
      [newOrderList[orderIndex], newOrderList[orderIndex + 1]] = [
        newOrderList[orderIndex + 1],
        newOrderList[orderIndex],
      ];

      await updateOrder(newOrderList[orderIndex + 1].H, orderIndex + 1);
      await updateOrder(newOrderList[orderIndex].H, orderIndex + 2);
    }

    setOrderList(newOrderList);
  };

  return (
    <div className="orders">
      <h1 className="title-role">הזמנות פעילות</h1>
      <span className="orders-header">
        {lastRefresh && (
          <div className="header-content">
            <button onClick={fetchOrders}>
              <MdRefresh />
            </button>
            <span>
              שעת ריענון: {lastRefresh} | כמות הזמנות: {orderCount}
            </span>
            {Object.entries(statusStyles).map(
              ([key, { backgroundColor, label }]) => (
                <div key={key} className="status-label">
                  <div
                    className="status-indicator"
                    style={{ backgroundColor }}
                  />
                  <span>{label}</span>
                </div>
              )
            )}
          </div>
        )}
      </span>
      <table className="orders-table">
        <tbody>
          <tr>
            <th></th>
            <th>מספר הזמנה</th>
            <th>שם הלקוח</th>
            <th>תאריך אספקה משוער</th>
            <th>סטטוס הזמנה</th>
            <th>סכום לתשלום</th>
            <th>סכום שלוקט</th>
            <th>סך פריטים להזמנה</th>
          </tr>
          {orderList.length > 0 ? (
            orderList.map((order) => {
              let rowStyle = {};
              let fontWeight = "normal";

              switch (order["S"]) {
                case 1:
                  rowStyle.backgroundColor = "#FF96FF97";
                  break;
                case 2:
                  rowStyle.backgroundColor = "Orange";
                  break;
                case 3:
                  rowStyle.backgroundColor = "red";
                  break;
                case 5:
                  rowStyle.backgroundColor = "LightYellow";
                  break;
                default:
                  rowStyle.backgroundColor = "";
              }

              if ([1, 2, 3].includes(order["e"])) {
                fontWeight = "bold";
              }

              return (
                <tr key={order.H} style={{ ...rowStyle, fontWeight }}>
                  <td>
                    {order["סטטוס הזמנה"] === "ממתין לליקוט" && (
                      <div>
                        <FaCircleArrowUp
                          className="icon"
                          onClick={() => moveOrder(order.H, "up")}
                        />
                        <FaCircleArrowDown
                          className="icon"
                          onClick={() => moveOrder(order.H, "down")}
                        />
                      </div>
                    )}
                  </td>
                  <td>
                    <p>{order["הזמנה"]}</p>
                  </td>
                  <td>
                    <p>{order["שם לקוח"]}</p>
                  </td>
                  <td>
                    <p>{order["אספקה משוער"]}</p>
                  </td>
                  <td>
                    {editingOrderId === order.H ? (
                      <select
                        value={selectedValues[order.H] || order.J}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setSelectedValues((prev) => ({
                            ...prev,
                            [order.H]: newValue,
                          }));
                          updateOrderStatus(order.H, parseInt(newValue));
                        }}
                        style={{ ...rowStyle, fontWeight, border: "none" }}
                        onBlur={() => {
                          setEditingOrderId(null);
                        }}
                      >
                        {orderStatuses.map((status) => (
                          <option key={status.id} value={status.id}>
                            {status.label}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ flexGrow: 1 }}>{order["סטטוס הזמנה"]}</p>
                        <TbEdit
                          className="icon"
                          onClick={() => {
                            setEditingOrderId(order.H);
                            setSelectedValues((prev) => ({
                              ...prev,
                              [order.H]: order.J,
                            }));
                          }}
                        />
                      </div>
                    )}
                  </td>

                  <td>
                    <p>{order["סכום לתשלום"]} ₪</p>
                  </td>
                  <td>
                    <p>{order["סכום הזמנה"]} ₪</p>
                  </td>
                  <td>
                    <p>{order["פריטים"]}</p>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="8">אין הזמנות זמינות</td>
            </tr>
          )}
        </tbody>
      </table>
      {orderList.length >= toShow && (
        <div className="pagination">
          <ul>
            <li
              onClick={() => toShowFun(25)}
              className={toShow === 25 ? "active" : null}
            >
              <span>25</span>
            </li>
            <li
              onClick={() => toShowFun(50)}
              className={toShow === 50 ? "active" : null}
            >
              <span>50</span>
            </li>
            <li
              onClick={() => toShowFun(100)}
              className={toShow === 100 ? "active" : null}
            >
              <span>100</span>
            </li>
          </ul>
          <ul>
            {cFrom > 0 ? (
              <li onClick={downPaggination}>
                <span>{"<"}</span>
              </li>
            ) : null}
            {pCounter.length
              ? pCounter.map((element, index) =>
                  index >= cFrom - 2 && index < cTo - 2 ? (
                    <li
                      key={index}
                      onClick={() =>
                        cFrom !== index ? showPaggination(element) : null
                      }
                      className={cFrom === index ? "active" : null}
                    >
                      <span>{element + 1}</span>
                    </li>
                  ) : null
                )
              : null}
            {cTo < pCounter.length ? (
              <li onClick={UpPaggination}>
                <span>{">"}</span>
              </li>
            ) : null}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Orders;
